(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("httpInterceptor", httpInterceptorFactory);

  /** @ngInject */
  function httpInterceptorFactory($q, $injector, sessionData) {
    var interceptor = {
      request: function (config) {
        var interceptorService = $injector.get("InterceptorEnum");

        if (
          interceptorService.isStringValid(config.url) &&
          interceptorService.isApiCall(config.url)
        ) {
          //grab the token
          var token = sessionData.getValue(sessionData.Keys.ACCESS_TOKEN_KEY);

          if (token) {
            // bind token to Authorization header for every api request
            config.headers["Authorization"] = "Bearer " + token;
          }
        }

        return config;
      },
      response: function (response) {
        return response;
      },
      responseError: function (response) {
        return $q.reject(response);
      }
    };

    return interceptor;
  }
})();
